function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.99998 2.37254L5.84498 4.21754C6.13748 4.51004 6.60998 4.51004 6.90248 4.21754C7.19498 3.92504 7.19498 3.45254 6.90248 3.16004L4.52498 0.775039C4.23248 0.482539 3.75998 0.482539 3.46748 0.775039L1.08998 3.16004C0.79748 3.45254 0.79748 3.92504 1.08998 4.21754C1.38248 4.51004 1.85498 4.51004 2.14748 4.21754L3.99998 2.37254ZM3.99998 11.6275L2.15498 9.78254C1.86248 9.49004 1.38998 9.49004 1.09748 9.78254C0.804981 10.075 0.804981 10.5475 1.09748 10.84L3.47498 13.225C3.76748 13.5175 4.23998 13.5175 4.53248 13.225L6.90998 10.8475C7.20248 10.555 7.20248 10.0825 6.90998 9.79004C6.61748 9.49754 6.14498 9.49754 5.85248 9.79004L3.99998 11.6275Z",
  fill: "#F4536E"
});

function SvgShowMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowMore);
export default __webpack_public_path__ + "static/media/ShowMore.32476ffc.svg";
export { ForwardRef as ReactComponent };